import React, { Component } from "react";
import HeaderNav from "./common/HeaderNav";
import "./styles/Number.css";
import "./styles/Checkout.css";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import EditIcon from "@mui/icons-material/Edit";
import apiCall, { guestSessionManager } from "../utils/apiCall";
import { Table } from "../component/common/Table";
import { connect } from "react-redux";
import { cartInfo } from "./common/redux/actions";
import { activeUser } from "./common/redux/actions";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BusinessIcon from "@mui/icons-material/Business";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import FlagIcon from "@mui/icons-material/Flag";

import CircularProgress from "@mui/material/CircularProgress";

import queryString from "query-string";
import { toast } from "react-toastify";

let mountLimit = 1;
const theme = createTheme();
const columns = [
  { id: "number", label: "Number", minWidth: "20%" },
  { id: "discountedPrice", label: "Price", minWidth: "20%" },
  { id: "status", label: "Status", minWidth: "20%" },
];
const requiredBillingFileds = [
  "firstName",
  "lastName",
  "email",
  "contactNumber",
  "addressLine1",
  "city",
  "state",
  "postalCode",
];

class Checkout extends Component {
  state = {
    cartData: [],
    addressData: [],
    totalSize: 20,
    rowsPerPage: 20,
    filterData: {},
    getCartLimit: 20,
    billingDetails: { country: "India" },
    billingDetailsError: {},
    allowPayNow: false,
    payNowLoading: false,
  };

  async componentDidMount() {
    if (mountLimit == 1) {
      mountLimit++;
      try {
        // ADD TO CART IF CLICK ON DIRECT BUY NOW BUTTON
        let addToCart = false;
        let addToCartPayload = {
          userId: this.props.state.activeUser.isUserVerified
            ? this.props.state.activeUser.currentUser.id
            : null,
        };
        let numberIdToAdd = null;
        if (window.location.search) {
          let queryParams = queryString.parse(window.location.search);
          addToCart = queryParams.addtoCart == "true" ? true : false;
          numberIdToAdd = queryParams.numberId;
          addToCartPayload["numberId"] = numberIdToAdd;
        }
        // Always fetch cart first
        const { result } = await apiCall(
          "REACT_APP_GET_CART",
          "POST",
          {
            limit: this.state.getCartLimit || 20,
            skip: 0,
            getIdFromUserInfo: true,
          },
          false
        );
        // Check for duplicate before adding
        let alreadyInCart = false;
        if (addToCart && numberIdToAdd && result && result["success"] && result["status"]) {
          alreadyInCart = result.status.some(
            (item) => String(item.numberId) === String(numberIdToAdd)
          );
        }
        if (addToCart && numberIdToAdd && !alreadyInCart) {
          await apiCall(
            "REACT_APP_ADD_TO_CART",
            "POST",
            addToCartPayload,
            false
          );
          toast.success("Item added to cart");
        } else if (addToCart && numberIdToAdd && alreadyInCart) {
          toast.info("Item is already in your cart");
        }
        // Remove addtoCart and numberId from URL
        if (addToCart && numberIdToAdd) {
          const url = new URL(window.location);
          url.searchParams.delete("addtoCart");
          url.searchParams.delete("numberId");
          window.history.replaceState({}, document.title, url.pathname + url.search);
        }
        // GET CART DATA
        const { result: cartResult } = await apiCall(
          "REACT_APP_GET_CART",
          "POST",
          {
            limit: this.state.getCartLimit || 20,
            skip: 0,
            getIdFromUserInfo: true,
          },
          false
        );
        if (cartResult && cartResult["success"] && cartResult["status"]) {
          let modifyData = await this.modifyApiData(cartResult.status);
          let allowPayNow = true;
          modifyData.forEach((data) => {
            if (data.status && data.status != "Ready to port") {
              allowPayNow = false;
            }
          });
          this.setState({
            cartData: modifyData,
            totalSize: cartResult.totalSize,
            allowPayNow,
          });
        }
        // GET BILLING DATA
        const { result: getAddress } = await apiCall(
          "REACT_APP_GET_ADDRESS",
          "POST",
          {
            getIdFromUserInfo: true,
            limit: this.state.getCartLimit || 20,
            skip: 0,
          },
          false
        );
        if (getAddress && getAddress["success"] && getAddress["status"]) {
          let modifyData = await this.modifyApiData(getAddress["status"]);
          this.setState({
            addressData: modifyData,
            billingDetails: modifyData[0],
          });
        }
      } catch (error) {
        console.log("Checkout componentDidMount Error ::", error);
      }
      setTimeout(() => {
        mountLimit--;
      }, 500);
    }
  }

  async modifyApiData(rawDataArray) {
    return await rawDataArray.map((data) => {
      data.createdAt = new Date(data.createdAt).toLocaleString();
      data.updatedAt = new Date(data.updatedAt).toLocaleString();

      if (data.status) {
        data.status = data.status == 2 ? "Ready to port" : "Sold";
      }

      // calculate discounted price if discount is available
      if (data.discount && data.discount > 0) {
        data.discountedPrice = data.price - (data.price * data.discount) / 100;
      } else {
        data.discountedPrice = data.price;
      }

      return data;
    });
  }

  handleChangePage = async (chnagedPage, rowsPerPage) => {
    return false;
  };

  handleChange = async (event, state) => {
    let billingDetails = this.state.billingDetails;
    billingDetails[state] = event.target.value;
    this.setState({ billingDetails });
  };

  render() {
    console.log("checkout.js :: this.state :::::::::::::::", this.state);
    console.log("checkout.js :: this.props :::::::::::::::", this.props);

    const handleSubmit = async (event) => {
      event.preventDefault();

      if (!this.state.allowPayNow) {
        toast.error("remove sold numbers from cart to checkout");
        return;
      }

      let billingDetails = this.state.billingDetails;
      let billingDetailsError = { ...this.state.billingDetailsError };
      let goAhead = true;

      for (let field of requiredBillingFileds) {
        if (!billingDetails[field]) {
          billingDetailsError[field] = `${field} is mandatory`;
          goAhead = false;
        } else {
          let value = billingDetails[field];
          let error = "";

          if (["firstName", "lastName", "city", "state"].includes(field)) {
            if (typeof value !== "string")
              error += `${field} should be string, `;
            if (value.length < 2) error += `${field} must be min of 2 char, `;
            if (value.length > 15) error += `${field} must be max of 15 char, `;
          }

          if (
            field === "email" &&
            !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)
          ) {
            error += `${field} should be a valid email, `;
          }

          if (["contactNumber", "postalCode"].includes(field)) {
            if (!/^\d+$/.test(value)) {
              error += `${field} should be a number, `;
            } else if (
              (field === "contactNumber" && value.length !== 10) ||
              (field === "postalCode" && value.length !== 6)
            ) {
              error += `${field} must be ${
                field === "contactNumber" ? 10 : 6
              } digits, `;
            }
          }

          if (error) goAhead = false;
          billingDetailsError[field] = error;
        }
      }

      this.setState({ billingDetailsError });

      if (!goAhead) return;

      try {
        if (this.props.state.activeUser.currentUser.isGuest) {
          const password = Math.random().toString(36).substr(2, 9);
          const { result: emailCheckResult } = await apiCall(
            "REACT_APP_GET_USER",
            "POST",
            { email: billingDetails.email },
            false
          );

          if (emailCheckResult?.data) {
            const { result } = await apiCall("REACT_APP_LOGIN_URL", "POST", {
              email: emailCheckResult.data.email,
              password: "GUESTBYPASSLOGIN",
            });

            if (result?.success && result.status) {
              const newUserId = result.status.data.data.id;
              const guestId = guestSessionManager.getExistingSession();

              await apiCall("REACT_APP_UPDATE_CART", "POST", {
                oldGuestId: guestId,
                newUserId,
              });

              localStorage.setItem("token", result.status.token);

              await new Promise((resolve) => {
                this.props.activeUser({
                  isUserVerified: true,
                  currentUser: result.status.data,
                });
                resolve();
              });

              await new Promise((resolve) => {
                this.props.cartInfo([...this.state.cartData]);
                resolve();
              });
            } else {
              console.error("Login failed:", result);
              return;
            }
          } else {
            const { user } = await apiCall("REACT_APP_SIGNUP_URL", "POST", {
              firstName: billingDetails?.firstName,
              lastName: billingDetails?.lastName,
              email: billingDetails?.email,
              password,
              confirm_password: password,
            });

            const { result } = await apiCall("REACT_APP_LOGIN_URL", "POST", {
              email: billingDetails.email,
              password,
            });

            if (result?.success && result.status) {
              const newUserId = result.status.data.data.id;
              const guestId = guestSessionManager.getExistingSession();

              await apiCall("REACT_APP_UPDATE_CART", "POST", {
                oldGuestId: guestId,
                newUserId,
              });

              localStorage.setItem("token", result.status.token);

              await new Promise((resolve) => {
                this.props.activeUser({
                  isUserVerified: true,
                  currentUser: result.status.data,
                });
                resolve();
              });

              await new Promise((resolve) => {
                this.props.cartInfo([...this.state.cartData]);
                resolve();
              });
            } else {
              console.error("Login failed:", result);
              return;
            }
          }
          
          // Clear guest session after successful conversion
          guestSessionManager.clearSession();
        }

        // Only set payNowLoading to true before order creation
        this.setState({ payNowLoading: true });

        const { result } = await apiCall("REACT_APP_CREATE_ORDER", "POST", {
          getIdFromUserInfo: true,
          cartId: this.state.cartData.map((eachData) => eachData.id),
          billingDetails: this.state.billingDetails,
        });

        if (result?.success && result.status?.short_url) {
          window.location.href = result.status.short_url;
        }
      } catch (error) {
        console.log("checkout.js :: handleSubmit Error :::::::::::::::", error);
      } finally {
        // Ensure payNowLoading is false even if there's an error
        this.setState({ payNowLoading: false });
      }
    };

    return (
      <React.Fragment>
        <div id="mainNumbersContainer">
          {/* render Header Nav Bar */}
          <HeaderNav
            activeTabName="checkout"
            cartCount={this.state.cartData.length}
          />

          <div id="subMainContainer" style={{ flexDirection: "column" }}>
            {/* render numbers container with conditions */}
            <div id="CheckoutSubContainer">
              <div className="checkoutTitle">
                <h3>Checkout Details</h3>
              </div>
              <div className="checkoutMain">
                <div className="checkoutSub">
                  <ThemeProvider theme={theme}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Typography component="h1" variant="h5">
                        Billing Details
                      </Typography>
                      <div id="billingDetailBox">
                        <Box Validate>
                          <Grid container spacing={2}>
                            <Grid item xs>
                              <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="firstName"
                                label="First Name"
                                type="text"
                                id="firstName"
                                autoComplete="given-name"
                                size="small"
                                value={this.state.billingDetails.firstName}
                                onChange={(e) => {
                                  this.handleChange(e, "firstName");
                                }}
                                error={
                                  this.state.billingDetailsError.firstName
                                    ? true
                                    : false
                                }
                                helperText={
                                  this.state.billingDetailsError.firstName
                                }
                                InputLabelProps={
                                  this.state.billingDetails.firstName
                                    ? { shrink: true }
                                    : {}
                                }
                              />
                            </Grid>
                            <Grid item xs>
                              <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="lastName"
                                label="Last Name"
                                type="text"
                                id="lastName"
                                autoComplete="family-name"
                                size="small"
                                value={this.state.billingDetails.lastName}
                                onChange={(e) => {
                                  this.handleChange(e, "lastName");
                                }}
                                error={
                                  this.state.billingDetailsError.lastName
                                    ? true
                                    : false
                                }
                                helperText={
                                  this.state.billingDetailsError.lastName
                                }
                                InputLabelProps={
                                  this.state.billingDetails.lastName
                                    ? { shrink: true }
                                    : {}
                                }
                              />
                            </Grid>
                          </Grid>
                          <Grid item xs>
                            <TextField
                              margin="normal"
                              required
                              fullWidth
                              id="email"
                              label="Email Address"
                              name="email"
                              autoComplete="email"
                              size="small"
                              value={this.state.billingDetails.email}
                              onChange={(e) => {
                                this.handleChange(e, "email");
                              }}
                              error={
                                this.state.billingDetailsError.email
                                  ? true
                                  : false
                              }
                              helperText={this.state.billingDetailsError.email}
                              InputLabelProps={
                                this.state.billingDetails.email
                                  ? { shrink: true }
                                  : {}
                              }
                            />
                            <TextField
                              margin="normal"
                              required
                              fullWidth
                              name="contactNumber"
                              label="Contact Number"
                              type="tel"
                              id="contactNumber"
                              autoComplete="tel"
                              size="small"
                              value={this.state.billingDetails.contactNumber}
                              onChange={(e) => {
                                this.handleChange(e, "contactNumber");
                              }}
                              error={
                                this.state.billingDetailsError.contactNumber
                                  ? true
                                  : false
                              }
                              helperText={
                                this.state.billingDetailsError.contactNumber
                              }
                              InputLabelProps={
                                this.state.billingDetails.contactNumber
                                  ? { shrink: true }
                                  : {}
                              }
                            />
                            <TextField
                              margin="normal"
                              required
                              fullWidth
                              name="addressLine1"
                              label="Address Line 1"
                              type="address-line1"
                              id="addressLine1"
                              autoComplete="address-line1"
                              size="small"
                              value={this.state.billingDetails.addressLine1}
                              onChange={(e) => {
                                this.handleChange(e, "addressLine1");
                              }}
                              error={
                                this.state.billingDetailsError.addressLine1
                                  ? true
                                  : false
                              }
                              helperText={
                                this.state.billingDetailsError.addressLine1
                              }
                              InputLabelProps={
                                this.state.billingDetails.addressLine1
                                  ? { shrink: true }
                                  : {}
                              }
                            />
                            <TextField
                              margin="normal"
                              fullWidth
                              name="addressLine2"
                              label="Address Line 2"
                              type="address-line2"
                              id="addressLine2"
                              autoComplete="address-line2"
                              size="small"
                              value={this.state.billingDetails.addressLine2}
                              onChange={(e) => {
                                this.handleChange(e, "addressLine2");
                              }}
                              error={
                                this.state.billingDetailsError.addressLine2
                                  ? true
                                  : false
                              }
                              helperText={
                                this.state.billingDetailsError.addressLine2
                              }
                              InputLabelProps={
                                this.state.billingDetails.addressLine2
                                  ? { shrink: true }
                                  : {}
                              }
                            />
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid item xs>
                              <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="city"
                                label="City"
                                type="text"
                                id="city"
                                autoComplete="address-level2"
                                size="small"
                                value={this.state.billingDetails.city}
                                onChange={(e) => {
                                  this.handleChange(e, "city");
                                }}
                                error={
                                  this.state.billingDetailsError.city
                                    ? true
                                    : false
                                }
                                helperText={this.state.billingDetailsError.city}
                                InputLabelProps={
                                  this.state.billingDetails.city
                                    ? { shrink: true }
                                    : {}
                                }
                              />
                            </Grid>
                            <Grid item xs>
                              <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="state"
                                label="State"
                                type="text"
                                id="state"
                                autoComplete="address-level1"
                                size="small"
                                value={this.state.billingDetails.state}
                                onChange={(e) => {
                                  this.handleChange(e, "state");
                                }}
                                error={
                                  this.state.billingDetailsError.state
                                    ? true
                                    : false
                                }
                                helperText={
                                  this.state.billingDetailsError.state
                                }
                                InputLabelProps={
                                  this.state.billingDetails.state
                                    ? { shrink: true }
                                    : {}
                                }
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid item xs>
                              <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="postalCode"
                                label="Postal-Code"
                                type="number"
                                id="postalCode"
                                autoComplete="postal-code"
                                size="small"
                                value={this.state.billingDetails.postalCode}
                                onChange={(e) => {
                                  this.handleChange(e, "postalCode");
                                }}
                                error={
                                  this.state.billingDetailsError.postalCode
                                    ? true
                                    : false
                                }
                                helperText={
                                  this.state.billingDetailsError.postalCode
                                }
                                InputLabelProps={
                                  this.state.billingDetails.postalCode
                                    ? { shrink: true }
                                    : {}
                                }
                              />
                            </Grid>
                            <Grid item xs>
                              <TextField
                                margin="normal"
                                fullWidth
                                name="country"
                                label="Country (default)"
                                type="text"
                                id="country"
                                disabled
                                size="small"
                                value={this.state.billingDetails.country}
                                onChange={(e) => {
                                  this.handleChange(e, "country");
                                }}
                                error={
                                  this.state.billingDetailsError.country
                                    ? true
                                    : false
                                }
                                helperText={
                                  this.state.billingDetailsError.country
                                }
                                InputLabelProps={
                                  this.state.billingDetails.country
                                    ? { shrink: true }
                                    : {}
                                }
                              />
                            </Grid>
                          </Grid>
                        </Box>
                      </div>
                      {/* <Card sx={{ maxWidth: 345 }}>
                          <CardHeader sx={{paddingBottom : 0}}
                            avatar={
                              <Avatar sx={{ bgcolor: 'red[500]' }} aria-label="recipe">
                                HT
                              </Avatar>
                            }
                            title="Husain Thekiya"
                            subheader="hussainthekiya@gmail.com"
                          />
                          <CardContent>
                            <Typography variant="body2" color="text.primary">
                              <SmartphoneIcon/> 7506962431,
                            </Typography>
                            <Typography variant="body2" color="text.primary">
                              <LocationOnIcon/> address line 1 is compulsory, here and madnatory,
                            </Typography>
                            <Typography variant="body2" color="text.primary">
                              <LocationOnIcon/> address line 2 is optional,
                            </Typography>
                            <Typography variant="body2" color="text.primary">
                              <LocationCityIcon/> Thane - 400612, Maharashtra, India
                            </Typography>
                          </CardContent>
                        </Card> */}
                    </Box>
                  </ThemeProvider>
                </div>

                <div className="checkoutSub">
                  <ThemeProvider theme={theme}>
                    <Box
                      sx={{
                        width: "80%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Typography component="h1" variant="h5">
                        Product Details
                      </Typography>
                      <div id="checkoutTable">
                        <Table
                          width={"100%"}
                          maxHeight={"fit-content"}
                          columns={columns || []}
                          dataValues={this.state.cartData || []}
                          totalSize={this.state.totalSize || 0}
                          filterHeight={0}
                          rowsPerPage={this.state.rowsPerPage}
                          handleChangePage={this.handleChangePage}
                          showPriceTotal={true}
                        />
                      </div>
                      <div
                        className="cartFooter"
                        style={{ flexDirection: "column" }}
                      >
                        <Link to={"/cart"} style={{ textDecoration: "none" }}>
                          <Button
                            sx={{ mt: 3, mb: 1 }}
                            id="cartFooterButton"
                            fullWidth
                            variant="contained"
                          >
                            Edit Cart
                          </Button>
                        </Link>
                        <Button
                          id="checkoutFooterButton"
                          type="submit"
                          // fullWidth
                          variant="contained"
                          onClick={handleSubmit}
                          sx={{
                            mb: 2,
                            opacity: this.state.allowPayNow
                              ? this.state.payNowLoading
                                ? "0.4"
                                : "1"
                              : "0.4",
                          }}
                        >
                          {this.state.payNowLoading ? (
                            <CircularProgress color="success" size={"25px"} />
                          ) : (
                            "Pay Now"
                          )}
                        </Button>
                      </div>
                    </Box>
                  </ThemeProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps, { cartInfo, activeUser })(Checkout);
